export default __webpack_public_path__ + "static/img-nhs-kortical--mobile-607fe35e16e023a48342f20e116832d6.jpg";